import { render, staticRenderFns } from "./CustomerListMobile.vue?vue&type=template&id=f2d41470&scoped=true"
import script from "./CustomerListMobile.vue?vue&type=script&lang=ts"
export * from "./CustomerListMobile.vue?vue&type=script&lang=ts"
import style0 from "./CustomerListMobile.vue?vue&type=style&index=0&id=f2d41470&prod&lang=css"
import style1 from "./CustomerListMobile.vue?vue&type=style&index=1&id=f2d41470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d41470",
  null
  
)

export default component.exports